import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '../app.service';

@Component({
  selector: 'app-alert-confirm-notification',
  templateUrl: './alert-confirm-notification.component.html',
  styleUrls: ['./alert-confirm-notification.component.scss'],
})
export class AlertConfirmNotificationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AlertConfirmNotificationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private appState: AppState) { }

  ngOnInit() {    
  }
}
